// src/pages/ShopDetails.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';

const SHOP_API = 'https://oppiesfunc.azurewebsites.net/api/getShopById?code=TxEuYhVjo9rIiMlI2EMr8gRFPPRejKrTeKGMbTXwQ--3AzFuHMjRzQ==';
const REVIEW_API = 'https://oppiesfunc.azurewebsites.net/api/getReviewsByShop?code=DoHf7NWbvGWUlR3EADcU1aU9aM4pMnOYTivml1Ky27xRAzFuTKLPMQ==';
const DELETE_API = 'https://oppiesfunc.azurewebsites.net/api/deleteShop?code=IY5Wjkwpx9ZYDek6J5j6Mb_HqKzolY13tFDXybz22ezMAzFulJLWUw==';
const APPROVE_API = 'https://oppiesfunc.azurewebsites.net/api/approveShop?code=NrDKuYLjllR0_uPRfF3Sd-pOTd_itfOfYf2DSN4AxGFOAzFu7RKe7g==';

function ShopDetails() {
  const { shopId } = useParams();
  const history = useHistory();
  const [shop, setShop] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [status, setStatus] = useState('');

  useEffect(() => {
    fetchDetails();
  }, []);

  const fetchDetails = async () => {
    try {
      const shopRes = await axios.post(SHOP_API, { shopId });
      const reviewRes = await axios.post(REVIEW_API, { shopId });
      setShop(shopRes.data);
      setReviews(reviewRes.data);
    } catch (err) {
      setStatus('Error loading shop details.');
    }
  };

  const handleApprove = async () => {
    try {
      await axios.post(APPROVE_API, { shopId });
      setStatus('Shop approved.');
    } catch {
      setStatus('Approval failed.');
    }
  };

  const handleDelete = async () => {
    if (!window.confirm('Delete this shop?')) return;
    try {
      await axios.post(DELETE_API, { shopId });
      history.push('/'); // redirect back to main list
    } catch {
      setStatus('Delete failed.');
    }
  };

  if (!shop) return <p>Loading...</p>;

  return (
    <div style={styles.container}>
      <h2>{shop.name}</h2>
      <p><strong>Address:</strong> {shop.address}</p>
      <p><strong>Contact:</strong> {shop.contact}</p>
      <p><strong>Registered By:</strong> {shop.registeredBy}</p>
      <p><strong>Status:</strong> {shop.approved ? 'Approved' : 'Pending Approval'}</p>

      <div style={styles.buttons}>
        {!shop.approved && <button onClick={handleApprove} style={styles.approveBtn}>Approve</button>}
        <button onClick={handleDelete} style={styles.deleteBtn}>Delete Shop</button>
      </div>

      <h3>Reviews</h3>
      {reviews.length === 0 ? (
        <p>No reviews for this shop.</p>
      ) : (
        reviews.map((r) => (
          <div key={r.id} style={styles.review}>
            <p><strong>{r.userEmail}</strong>: {r.text}</p>
            <small>Rating: {r.rating} | {new Date(r.createdAt).toLocaleString()}</small>
          </div>
        ))
      )}
      {status && <p>{status}</p>}
    </div>
  );
}

const styles = {
  container: { maxWidth: 700, margin: '30px auto', padding: 20 },
  buttons: { marginTop: 10, marginBottom: 20 },
  approveBtn: {
    backgroundColor: '#4CAF50',
    color: 'white',
    padding: '8px 14px',
    marginRight: 10,
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
  },
  deleteBtn: {
    backgroundColor: '#cc0000',
    color: 'white',
    padding: '8px 14px',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
  },
  review: {
    background: '#f9f9f9',
    padding: 10,
    marginBottom: 10,
    borderRadius: 6,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
  }
};

export default ShopDetails;
